import dynamic from "next/dynamic";

import type { ColoredSectionStoryblok } from "@/types/blok-types";

import PassthroughFallback from "@/components/atoms/PassthroughFallback/PassthroughFallback";
import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import React from "react";

const ColorTrigger = dynamic(() => import("./ClientColorTrigger"), {
  loading: PassthroughFallback,
});

const ColoredSection = ({
  blok,
  preview,
}: {
  blok: ColoredSectionStoryblok;
  preview: boolean;
}): React.JSX.Element => {
  return (
    <ColorTrigger blok={blok}>
      <>
        {blok.content.map((b) => (
          <StoryblokComponent blok={b} key={b._uid} preview={preview} />
        ))}
      </>
    </ColorTrigger>
  );
};

export default ColoredSection;
